export enum TemporaryPasswordStatus {
  CURRENT = 0,
  IN_USE = 1,
  REVOKED = 2,
  EXPIRED = 3,
  USED = 4
}